export default {
  IN_PROGRESS: 'inprogress',
  SHOW_RESTRICTIONS: 'show_restrictions',
  DOWNLOADING: 'downloading',
  DOWNLOAD_COMPLETE: 'download_complete',
  DOWNLOAD_ERROR: 'download_error',
  COMPLETE: 'complete',
};
